module.exports = __webpack_public_path__ + "static/media/yelp-social-media-svgrepo-com (1).18e99fed.svg";